// This file is auto-generated by @hey-api/openapi-ts

import { type DefaultError, type InfiniteData, infiniteQueryOptions, queryOptions, type UseMutationOptions } from '@tanstack/react-query';

import { client } from '../client.gen';
import { deleteV1CommunicationTemplatesById, deleteV1InvoicesById, deleteV1JobsById, deleteV1KioskDevicesById, deleteV1OrganizationsById, deleteV1RolesById, deleteV1SparePartsById, deleteV1TimeEntries, deleteV1TimeEntriesById, deleteV1UsersById, deleteV1UsersByIdKioskPin, deleteV1UsersByIdProfileImage, deleteV1WorkflowsById, deleteV1WorkOrderErrandsById, deleteV1WorkOrdersByIdSignaturesBySignatureType, deleteV1WorkOrdersByIdUploadedImages, deleteV1WorkshopsById, deleteV1WorkshopsByIdCabAccountsByCabAccountId, deleteV1WorkshopsByIdDealershipsByDealershipId, deleteV1WorkshopsByIdShelvesByShelfId, getV1AuditLogs, getV1AuditLogsCursor, getV1CabasEstimates, getV1CabasEstimatesById, getV1Capacity, getV1Cars, getV1CarsById, getV1CheckpointResponses, getV1CheckpointResponsesById, getV1CheckpointResponsesImages, getV1Communication, getV1CommunicationById, getV1CommunicationTemplates, getV1CommunicationTemplatesById, getV1Config, getV1FinalCalculations, getV1InsuranceCompanies, getV1Invoices, getV1InvoicesById, getV1Jobs, getV1JobsById, getV1KioskDevices, getV1KioskPunchReasons, getV1KioskStaff, getV1KioskStaffByUserIdPhoto, getV1KioskStopReasons, getV1Notifications, getV1Organizations, getV1OrganizationsById, getV1PunchReasons, getV1Roles, getV1RolesById, getV1SignatureLinksByToken, getV1SparePartOrders, getV1SparePartOrdersById, getV1SpareParts, getV1StopReasons, getV1TimeEntries, getV1TimeEntriesPunchStatus, getV1Users, getV1UsersById, getV1UsersMe, getV1UsersPermissions, getV1Workflows, getV1WorkflowsById, getV1WorkOrderErrands, getV1WorkOrderErrandsById, getV1WorkOrders, getV1WorkOrdersAssignedByUserId, getV1WorkOrdersById, getV1WorkOrdersLateOrders, getV1WorkOrdersSearch, getV1WorkOrdersTimeEntriesByUserId, getV1Workshops, getV1WorkshopsById, getV1WorkshopsByIdCabAccounts, getV1WorkshopsByIdDealerships, getV1WorkshopsByIdShelves, getV1WorkshopsByIdWorkflows, type Options, patchV1CheckpointResponsesById, patchV1ClientsByIdOverrides, patchV1CommunicationTemplatesById, patchV1InvoicesById, patchV1JobsById, patchV1JobsByIdPlannedDate, patchV1OrganizationsById, patchV1RepairPartsStatus, patchV1RolesById, patchV1SparePartOrdersById, patchV1SpareParts, patchV1TimeEntriesById, patchV1UsersById, patchV1UsersByIdRole, patchV1UsersMe, patchV1WorkflowsById, patchV1WorkOrderErrandsById, patchV1WorkOrdersById, patchV1WorkOrdersByIdPaintedLackItems, patchV1WorkOrdersByIdTime, patchV1WorkshopsById, patchV1WorkshopsByIdCabAccountsByCabAccountId, patchV1WorkshopsByIdDealershipsByDealershipId, patchV1WorkshopsByIdShelvesByShelfId, postV1CheckpointResponses, postV1CheckpointResponsesUploadUrls, postV1Communication, postV1CommunicationTemplates, postV1Invoices, postV1Jobs, postV1KioskDevices, postV1KioskDevicesByIdRemove, postV1KioskPair, postV1KioskPinSetup, postV1KioskPinSetupVerifyPassword, postV1KioskPunch, postV1KioskSessions, postV1Organizations, postV1Roles, postV1SignatureLinksByTokenSubmit, postV1SparePartOrders, postV1SparePartOrdersByIdSend, postV1TimeEntriesAbsence, postV1TimeEntriesJob, postV1TimeEntriesPunch, postV1UsersByIdProfileImage, postV1UsersForgotPassword, postV1UsersInvite, postV1Workflows, postV1WorkOrderErrands, postV1WorkOrderErrandsUploadUrls, postV1WorkOrdersByIdMove, postV1WorkOrdersByIdPlanned, postV1WorkOrdersByIdRepairPartsSendToPaint, postV1WorkOrdersByIdSendSignatureRequest, postV1WorkOrdersByIdSign, postV1WorkOrdersByIdSignatureLink, postV1WorkOrdersByIdTime, postV1WorkOrdersByIdTimeEntry, postV1WorkOrdersByIdUploadedImages, postV1WorkOrdersByIdUploadedImagesUploadUrls, postV1Workshops, postV1WorkshopsByIdCabAccounts, postV1WorkshopsByIdDealerships, postV1WorkshopsByIdShelves, putV1UsersMeKioskPin } from '../sdk.gen';
import type { DeleteV1CommunicationTemplatesByIdData, DeleteV1InvoicesByIdData, DeleteV1JobsByIdData, DeleteV1KioskDevicesByIdData, DeleteV1OrganizationsByIdData, DeleteV1RolesByIdData, DeleteV1SparePartsByIdData, DeleteV1TimeEntriesByIdData, DeleteV1TimeEntriesData, DeleteV1UsersByIdData, DeleteV1UsersByIdKioskPinData, DeleteV1UsersByIdKioskPinResponse, DeleteV1UsersByIdProfileImageData, DeleteV1UsersByIdProfileImageResponse, DeleteV1WorkflowsByIdData, DeleteV1WorkOrderErrandsByIdData, DeleteV1WorkOrdersByIdSignaturesBySignatureTypeData, DeleteV1WorkOrdersByIdUploadedImagesData, DeleteV1WorkOrdersByIdUploadedImagesResponse, DeleteV1WorkshopsByIdCabAccountsByCabAccountIdData, DeleteV1WorkshopsByIdData, DeleteV1WorkshopsByIdDealershipsByDealershipIdData, DeleteV1WorkshopsByIdShelvesByShelfIdData, GetV1AuditLogsCursorData, GetV1AuditLogsCursorResponse, GetV1AuditLogsData, GetV1AuditLogsResponse, GetV1CabasEstimatesByIdData, GetV1CabasEstimatesByIdResponse, GetV1CabasEstimatesData, GetV1CabasEstimatesResponse, GetV1CapacityData, GetV1CapacityResponse, GetV1CarsByIdData, GetV1CarsByIdResponse, GetV1CarsData, GetV1CarsResponse, GetV1CheckpointResponsesByIdData, GetV1CheckpointResponsesByIdResponse, GetV1CheckpointResponsesData, GetV1CheckpointResponsesImagesData, GetV1CheckpointResponsesImagesResponse, GetV1CheckpointResponsesResponse, GetV1CommunicationByIdData, GetV1CommunicationByIdResponse, GetV1CommunicationData, GetV1CommunicationResponse, GetV1CommunicationTemplatesByIdData, GetV1CommunicationTemplatesByIdResponse, GetV1CommunicationTemplatesData, GetV1CommunicationTemplatesResponse, GetV1ConfigData, GetV1ConfigResponse, GetV1FinalCalculationsData, GetV1FinalCalculationsResponse, GetV1InsuranceCompaniesData, GetV1InsuranceCompaniesResponse, GetV1InvoicesByIdData, GetV1InvoicesByIdResponse, GetV1InvoicesData, GetV1InvoicesResponse, GetV1JobsByIdData, GetV1JobsByIdResponse, GetV1JobsData, GetV1JobsResponse, GetV1KioskDevicesData, GetV1KioskDevicesResponse, GetV1KioskPunchReasonsData, GetV1KioskPunchReasonsResponse, GetV1KioskStaffByUserIdPhotoData, GetV1KioskStaffByUserIdPhotoResponse, GetV1KioskStaffData, GetV1KioskStaffResponse, GetV1KioskStopReasonsData, GetV1KioskStopReasonsResponse, GetV1NotificationsData, GetV1NotificationsResponse, GetV1OrganizationsByIdData, GetV1OrganizationsByIdResponse, GetV1OrganizationsData, GetV1OrganizationsResponse, GetV1PunchReasonsData, GetV1PunchReasonsResponse, GetV1RolesByIdData, GetV1RolesByIdResponse, GetV1RolesData, GetV1RolesResponse, GetV1SignatureLinksByTokenData, GetV1SignatureLinksByTokenResponse, GetV1SparePartOrdersByIdData, GetV1SparePartOrdersByIdResponse, GetV1SparePartOrdersData, GetV1SparePartOrdersResponse, GetV1SparePartsData, GetV1SparePartsError, GetV1SparePartsResponse, GetV1StopReasonsData, GetV1StopReasonsResponse, GetV1TimeEntriesData, GetV1TimeEntriesPunchStatusData, GetV1TimeEntriesPunchStatusResponse, GetV1TimeEntriesResponse, GetV1UsersByIdData, GetV1UsersByIdResponse, GetV1UsersData, GetV1UsersMeData, GetV1UsersMeResponse, GetV1UsersPermissionsData, GetV1UsersPermissionsResponse, GetV1UsersResponse, GetV1WorkflowsByIdData, GetV1WorkflowsByIdResponse, GetV1WorkflowsData, GetV1WorkflowsResponse, GetV1WorkOrderErrandsByIdData, GetV1WorkOrderErrandsByIdResponse, GetV1WorkOrderErrandsData, GetV1WorkOrderErrandsResponse, GetV1WorkOrdersAssignedByUserIdData, GetV1WorkOrdersAssignedByUserIdResponse, GetV1WorkOrdersByIdData, GetV1WorkOrdersByIdResponse, GetV1WorkOrdersData, GetV1WorkOrdersLateOrdersData, GetV1WorkOrdersLateOrdersResponse, GetV1WorkOrdersResponse, GetV1WorkOrdersSearchData, GetV1WorkOrdersSearchResponse, GetV1WorkOrdersTimeEntriesByUserIdData, GetV1WorkOrdersTimeEntriesByUserIdResponse, GetV1WorkshopsByIdCabAccountsData, GetV1WorkshopsByIdCabAccountsResponse, GetV1WorkshopsByIdData, GetV1WorkshopsByIdDealershipsData, GetV1WorkshopsByIdDealershipsResponse, GetV1WorkshopsByIdResponse, GetV1WorkshopsByIdShelvesData, GetV1WorkshopsByIdShelvesResponse, GetV1WorkshopsByIdWorkflowsData, GetV1WorkshopsByIdWorkflowsResponse, GetV1WorkshopsData, GetV1WorkshopsResponse, PatchV1CheckpointResponsesByIdData, PatchV1CheckpointResponsesByIdResponse, PatchV1ClientsByIdOverridesData, PatchV1ClientsByIdOverridesResponse, PatchV1CommunicationTemplatesByIdData, PatchV1CommunicationTemplatesByIdResponse, PatchV1InvoicesByIdData, PatchV1InvoicesByIdResponse, PatchV1JobsByIdData, PatchV1JobsByIdPlannedDateData, PatchV1JobsByIdPlannedDateResponse, PatchV1JobsByIdResponse, PatchV1OrganizationsByIdData, PatchV1OrganizationsByIdResponse, PatchV1RepairPartsStatusData, PatchV1RepairPartsStatusResponse, PatchV1RolesByIdData, PatchV1RolesByIdResponse, PatchV1SparePartOrdersByIdData, PatchV1SparePartOrdersByIdResponse, PatchV1SparePartsData, PatchV1SparePartsResponse, PatchV1TimeEntriesByIdData, PatchV1TimeEntriesByIdResponse, PatchV1UsersByIdData, PatchV1UsersByIdResponse, PatchV1UsersByIdRoleData, PatchV1UsersByIdRoleResponse, PatchV1UsersMeData, PatchV1UsersMeResponse, PatchV1WorkflowsByIdData, PatchV1WorkflowsByIdResponse, PatchV1WorkOrderErrandsByIdData, PatchV1WorkOrderErrandsByIdResponse, PatchV1WorkOrdersByIdData, PatchV1WorkOrdersByIdPaintedLackItemsData, PatchV1WorkOrdersByIdPaintedLackItemsResponse, PatchV1WorkOrdersByIdResponse, PatchV1WorkOrdersByIdTimeData, PatchV1WorkOrdersByIdTimeResponse, PatchV1WorkshopsByIdCabAccountsByCabAccountIdData, PatchV1WorkshopsByIdCabAccountsByCabAccountIdResponse, PatchV1WorkshopsByIdData, PatchV1WorkshopsByIdDealershipsByDealershipIdData, PatchV1WorkshopsByIdDealershipsByDealershipIdResponse, PatchV1WorkshopsByIdResponse, PatchV1WorkshopsByIdShelvesByShelfIdData, PatchV1WorkshopsByIdShelvesByShelfIdResponse, PostV1CheckpointResponsesData, PostV1CheckpointResponsesResponse, PostV1CheckpointResponsesUploadUrlsData, PostV1CheckpointResponsesUploadUrlsResponse, PostV1CommunicationData, PostV1CommunicationResponse, PostV1CommunicationTemplatesData, PostV1CommunicationTemplatesResponse, PostV1InvoicesData, PostV1InvoicesResponse, PostV1JobsData, PostV1JobsResponse, PostV1KioskDevicesByIdRemoveData, PostV1KioskDevicesData, PostV1KioskDevicesResponse, PostV1KioskPairData, PostV1KioskPairResponse, PostV1KioskPinSetupData, PostV1KioskPinSetupResponse, PostV1KioskPinSetupVerifyPasswordData, PostV1KioskPinSetupVerifyPasswordResponse, PostV1KioskPunchData, PostV1KioskPunchResponse, PostV1KioskSessionsData, PostV1KioskSessionsResponse, PostV1OrganizationsData, PostV1OrganizationsResponse, PostV1RolesData, PostV1RolesResponse, PostV1SignatureLinksByTokenSubmitData, PostV1SparePartOrdersByIdSendData, PostV1SparePartOrdersByIdSendResponse, PostV1SparePartOrdersData, PostV1SparePartOrdersResponse, PostV1TimeEntriesAbsenceData, PostV1TimeEntriesAbsenceResponse, PostV1TimeEntriesJobData, PostV1TimeEntriesJobResponse, PostV1TimeEntriesPunchData, PostV1TimeEntriesPunchResponse, PostV1UsersByIdProfileImageData, PostV1UsersByIdProfileImageResponse, PostV1UsersForgotPasswordData, PostV1UsersInviteData, PostV1UsersInviteResponse, PostV1WorkflowsData, PostV1WorkflowsResponse, PostV1WorkOrderErrandsData, PostV1WorkOrderErrandsResponse, PostV1WorkOrderErrandsUploadUrlsData, PostV1WorkOrderErrandsUploadUrlsResponse, PostV1WorkOrdersByIdMoveData, PostV1WorkOrdersByIdMoveResponse, PostV1WorkOrdersByIdPlannedData, PostV1WorkOrdersByIdPlannedResponse, PostV1WorkOrdersByIdRepairPartsSendToPaintData, PostV1WorkOrdersByIdRepairPartsSendToPaintResponse, PostV1WorkOrdersByIdSendSignatureRequestData, PostV1WorkOrdersByIdSignatureLinkData, PostV1WorkOrdersByIdSignatureLinkResponse, PostV1WorkOrdersByIdSignData, PostV1WorkOrdersByIdTimeData, PostV1WorkOrdersByIdTimeEntryData, PostV1WorkOrdersByIdTimeEntryResponse, PostV1WorkOrdersByIdTimeResponse, PostV1WorkOrdersByIdUploadedImagesData, PostV1WorkOrdersByIdUploadedImagesResponse, PostV1WorkOrdersByIdUploadedImagesUploadUrlsData, PostV1WorkOrdersByIdUploadedImagesUploadUrlsResponse, PostV1WorkshopsByIdCabAccountsData, PostV1WorkshopsByIdCabAccountsResponse, PostV1WorkshopsByIdDealershipsData, PostV1WorkshopsByIdDealershipsResponse, PostV1WorkshopsByIdShelvesData, PostV1WorkshopsByIdShelvesResponse, PostV1WorkshopsData, PostV1WorkshopsResponse, PutV1UsersMeKioskPinData, PutV1UsersMeKioskPinResponse } from '../types.gen';

export const postV1UsersForgotPasswordMutation = (options?: Partial<Options<PostV1UsersForgotPasswordData>>): UseMutationOptions<unknown, DefaultError, Options<PostV1UsersForgotPasswordData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<PostV1UsersForgotPasswordData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postV1UsersForgotPassword({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export type QueryKey<TOptions extends Options> = [
    Pick<TOptions, 'baseUrl' | 'body' | 'headers' | 'path' | 'query'> & {
        _id: string;
        _infinite?: boolean;
        tags?: ReadonlyArray<string>;
    }
];

const createQueryKey = <TOptions extends Options>(id: string, options?: TOptions, infinite?: boolean, tags?: ReadonlyArray<string>): [
    QueryKey<TOptions>[0]
] => {
    const params: QueryKey<TOptions>[0] = { _id: id, baseUrl: options?.baseUrl || (options?.client ?? client).getConfig().baseUrl } as QueryKey<TOptions>[0];
    if (infinite) {
        params._infinite = infinite;
    }
    if (tags) {
        params.tags = tags;
    }
    if (options?.body) {
        params.body = options.body;
    }
    if (options?.headers) {
        params.headers = options.headers;
    }
    if (options?.path) {
        params.path = options.path;
    }
    if (options?.query) {
        params.query = options.query;
    }
    return [params];
};

export const getV1UsersQueryKey = (options?: Options<GetV1UsersData>) => createQueryKey('getV1Users', options);

export const getV1UsersOptions = (options?: Options<GetV1UsersData>) => queryOptions<GetV1UsersResponse, DefaultError, GetV1UsersResponse, ReturnType<typeof getV1UsersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getV1Users({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getV1UsersQueryKey(options)
});

export const postV1UsersInviteMutation = (options?: Partial<Options<PostV1UsersInviteData>>): UseMutationOptions<PostV1UsersInviteResponse, DefaultError, Options<PostV1UsersInviteData>> => {
    const mutationOptions: UseMutationOptions<PostV1UsersInviteResponse, DefaultError, Options<PostV1UsersInviteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postV1UsersInvite({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getV1UsersPermissionsQueryKey = (options?: Options<GetV1UsersPermissionsData>) => createQueryKey('getV1UsersPermissions', options);

export const getV1UsersPermissionsOptions = (options?: Options<GetV1UsersPermissionsData>) => queryOptions<GetV1UsersPermissionsResponse, DefaultError, GetV1UsersPermissionsResponse, ReturnType<typeof getV1UsersPermissionsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getV1UsersPermissions({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getV1UsersPermissionsQueryKey(options)
});

export const getV1UsersMeQueryKey = (options?: Options<GetV1UsersMeData>) => createQueryKey('getV1UsersMe', options);

export const getV1UsersMeOptions = (options?: Options<GetV1UsersMeData>) => queryOptions<GetV1UsersMeResponse, DefaultError, GetV1UsersMeResponse, ReturnType<typeof getV1UsersMeQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getV1UsersMe({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getV1UsersMeQueryKey(options)
});

export const patchV1UsersMeMutation = (options?: Partial<Options<PatchV1UsersMeData>>): UseMutationOptions<PatchV1UsersMeResponse, DefaultError, Options<PatchV1UsersMeData>> => {
    const mutationOptions: UseMutationOptions<PatchV1UsersMeResponse, DefaultError, Options<PatchV1UsersMeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await patchV1UsersMe({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const putV1UsersMeKioskPinMutation = (options?: Partial<Options<PutV1UsersMeKioskPinData>>): UseMutationOptions<PutV1UsersMeKioskPinResponse, DefaultError, Options<PutV1UsersMeKioskPinData>> => {
    const mutationOptions: UseMutationOptions<PutV1UsersMeKioskPinResponse, DefaultError, Options<PutV1UsersMeKioskPinData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await putV1UsersMeKioskPin({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const deleteV1UsersByIdMutation = (options?: Partial<Options<DeleteV1UsersByIdData>>): UseMutationOptions<unknown, DefaultError, Options<DeleteV1UsersByIdData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<DeleteV1UsersByIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteV1UsersById({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getV1UsersByIdQueryKey = (options: Options<GetV1UsersByIdData>) => createQueryKey('getV1UsersById', options);

export const getV1UsersByIdOptions = (options: Options<GetV1UsersByIdData>) => queryOptions<GetV1UsersByIdResponse, DefaultError, GetV1UsersByIdResponse, ReturnType<typeof getV1UsersByIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getV1UsersById({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getV1UsersByIdQueryKey(options)
});

export const patchV1UsersByIdMutation = (options?: Partial<Options<PatchV1UsersByIdData>>): UseMutationOptions<PatchV1UsersByIdResponse, DefaultError, Options<PatchV1UsersByIdData>> => {
    const mutationOptions: UseMutationOptions<PatchV1UsersByIdResponse, DefaultError, Options<PatchV1UsersByIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await patchV1UsersById({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const patchV1UsersByIdRoleMutation = (options?: Partial<Options<PatchV1UsersByIdRoleData>>): UseMutationOptions<PatchV1UsersByIdRoleResponse, DefaultError, Options<PatchV1UsersByIdRoleData>> => {
    const mutationOptions: UseMutationOptions<PatchV1UsersByIdRoleResponse, DefaultError, Options<PatchV1UsersByIdRoleData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await patchV1UsersByIdRole({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const deleteV1UsersByIdProfileImageMutation = (options?: Partial<Options<DeleteV1UsersByIdProfileImageData>>): UseMutationOptions<DeleteV1UsersByIdProfileImageResponse, DefaultError, Options<DeleteV1UsersByIdProfileImageData>> => {
    const mutationOptions: UseMutationOptions<DeleteV1UsersByIdProfileImageResponse, DefaultError, Options<DeleteV1UsersByIdProfileImageData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteV1UsersByIdProfileImage({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postV1UsersByIdProfileImageMutation = (options?: Partial<Options<PostV1UsersByIdProfileImageData>>): UseMutationOptions<PostV1UsersByIdProfileImageResponse, DefaultError, Options<PostV1UsersByIdProfileImageData>> => {
    const mutationOptions: UseMutationOptions<PostV1UsersByIdProfileImageResponse, DefaultError, Options<PostV1UsersByIdProfileImageData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postV1UsersByIdProfileImage({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const deleteV1UsersByIdKioskPinMutation = (options?: Partial<Options<DeleteV1UsersByIdKioskPinData>>): UseMutationOptions<DeleteV1UsersByIdKioskPinResponse, DefaultError, Options<DeleteV1UsersByIdKioskPinData>> => {
    const mutationOptions: UseMutationOptions<DeleteV1UsersByIdKioskPinResponse, DefaultError, Options<DeleteV1UsersByIdKioskPinData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteV1UsersByIdKioskPin({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getV1ConfigQueryKey = (options?: Options<GetV1ConfigData>) => createQueryKey('getV1Config', options);

export const getV1ConfigOptions = (options?: Options<GetV1ConfigData>) => queryOptions<GetV1ConfigResponse, DefaultError, GetV1ConfigResponse, ReturnType<typeof getV1ConfigQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getV1Config({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getV1ConfigQueryKey(options)
});

export const getV1AuditLogsQueryKey = (options: Options<GetV1AuditLogsData>) => createQueryKey('getV1AuditLogs', options);

export const getV1AuditLogsOptions = (options: Options<GetV1AuditLogsData>) => queryOptions<GetV1AuditLogsResponse, DefaultError, GetV1AuditLogsResponse, ReturnType<typeof getV1AuditLogsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getV1AuditLogs({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getV1AuditLogsQueryKey(options)
});

const createInfiniteParams = <K extends Pick<QueryKey<Options>[0], 'body' | 'headers' | 'path' | 'query'>>(queryKey: QueryKey<Options>, page: K) => {
    const params = { ...queryKey[0] };
    if (page.body) {
        params.body = {
            ...queryKey[0].body as any,
            ...page.body as any
        };
    }
    if (page.headers) {
        params.headers = {
            ...queryKey[0].headers,
            ...page.headers
        };
    }
    if (page.path) {
        params.path = {
            ...queryKey[0].path as any,
            ...page.path as any
        };
    }
    if (page.query) {
        params.query = {
            ...queryKey[0].query as any,
            ...page.query as any
        };
    }
    return params as unknown as typeof page;
};

export const getV1AuditLogsInfiniteQueryKey = (options: Options<GetV1AuditLogsData>): QueryKey<Options<GetV1AuditLogsData>> => createQueryKey('getV1AuditLogs', options, true);

export const getV1AuditLogsInfiniteOptions = (options: Options<GetV1AuditLogsData>) => {
    const opts = infiniteQueryOptions<GetV1AuditLogsResponse, DefaultError, InfiniteData<GetV1AuditLogsResponse>, QueryKey<Options<GetV1AuditLogsData>>, number | Pick<QueryKey<Options<GetV1AuditLogsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetV1AuditLogsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getV1AuditLogs({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getV1AuditLogsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const getV1AuditLogsCursorQueryKey = (options: Options<GetV1AuditLogsCursorData>) => createQueryKey('getV1AuditLogsCursor', options);

export const getV1AuditLogsCursorOptions = (options: Options<GetV1AuditLogsCursorData>) => queryOptions<GetV1AuditLogsCursorResponse, DefaultError, GetV1AuditLogsCursorResponse, ReturnType<typeof getV1AuditLogsCursorQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getV1AuditLogsCursor({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getV1AuditLogsCursorQueryKey(options)
});

export const getV1AuditLogsCursorInfiniteQueryKey = (options: Options<GetV1AuditLogsCursorData>): QueryKey<Options<GetV1AuditLogsCursorData>> => createQueryKey('getV1AuditLogsCursor', options, true);

export const getV1AuditLogsCursorInfiniteOptions = (options: Options<GetV1AuditLogsCursorData>) => {
    const opts = infiniteQueryOptions<GetV1AuditLogsCursorResponse, DefaultError, InfiniteData<GetV1AuditLogsCursorResponse>, QueryKey<Options<GetV1AuditLogsCursorData>>, string | Pick<QueryKey<Options<GetV1AuditLogsCursorData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetV1AuditLogsCursorData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    cursor: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getV1AuditLogsCursor({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getV1AuditLogsCursorInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const getV1OrganizationsQueryKey = (options: Options<GetV1OrganizationsData>) => createQueryKey('getV1Organizations', options);

export const getV1OrganizationsOptions = (options: Options<GetV1OrganizationsData>) => queryOptions<GetV1OrganizationsResponse, DefaultError, GetV1OrganizationsResponse, ReturnType<typeof getV1OrganizationsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getV1Organizations({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getV1OrganizationsQueryKey(options)
});

export const getV1OrganizationsInfiniteQueryKey = (options: Options<GetV1OrganizationsData>): QueryKey<Options<GetV1OrganizationsData>> => createQueryKey('getV1Organizations', options, true);

export const getV1OrganizationsInfiniteOptions = (options: Options<GetV1OrganizationsData>) => {
    const opts = infiniteQueryOptions<GetV1OrganizationsResponse, DefaultError, InfiniteData<GetV1OrganizationsResponse>, QueryKey<Options<GetV1OrganizationsData>>, number | Pick<QueryKey<Options<GetV1OrganizationsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetV1OrganizationsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getV1Organizations({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getV1OrganizationsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const postV1OrganizationsMutation = (options?: Partial<Options<PostV1OrganizationsData>>): UseMutationOptions<PostV1OrganizationsResponse, DefaultError, Options<PostV1OrganizationsData>> => {
    const mutationOptions: UseMutationOptions<PostV1OrganizationsResponse, DefaultError, Options<PostV1OrganizationsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postV1Organizations({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const deleteV1OrganizationsByIdMutation = (options?: Partial<Options<DeleteV1OrganizationsByIdData>>): UseMutationOptions<unknown, DefaultError, Options<DeleteV1OrganizationsByIdData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<DeleteV1OrganizationsByIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteV1OrganizationsById({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getV1OrganizationsByIdQueryKey = (options: Options<GetV1OrganizationsByIdData>) => createQueryKey('getV1OrganizationsById', options);

export const getV1OrganizationsByIdOptions = (options: Options<GetV1OrganizationsByIdData>) => queryOptions<GetV1OrganizationsByIdResponse, DefaultError, GetV1OrganizationsByIdResponse, ReturnType<typeof getV1OrganizationsByIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getV1OrganizationsById({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getV1OrganizationsByIdQueryKey(options)
});

export const patchV1OrganizationsByIdMutation = (options?: Partial<Options<PatchV1OrganizationsByIdData>>): UseMutationOptions<PatchV1OrganizationsByIdResponse, DefaultError, Options<PatchV1OrganizationsByIdData>> => {
    const mutationOptions: UseMutationOptions<PatchV1OrganizationsByIdResponse, DefaultError, Options<PatchV1OrganizationsByIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await patchV1OrganizationsById({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getV1RolesQueryKey = (options: Options<GetV1RolesData>) => createQueryKey('getV1Roles', options);

export const getV1RolesOptions = (options: Options<GetV1RolesData>) => queryOptions<GetV1RolesResponse, DefaultError, GetV1RolesResponse, ReturnType<typeof getV1RolesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getV1Roles({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getV1RolesQueryKey(options)
});

export const getV1RolesInfiniteQueryKey = (options: Options<GetV1RolesData>): QueryKey<Options<GetV1RolesData>> => createQueryKey('getV1Roles', options, true);

export const getV1RolesInfiniteOptions = (options: Options<GetV1RolesData>) => {
    const opts = infiniteQueryOptions<GetV1RolesResponse, DefaultError, InfiniteData<GetV1RolesResponse>, QueryKey<Options<GetV1RolesData>>, number | Pick<QueryKey<Options<GetV1RolesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetV1RolesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getV1Roles({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getV1RolesInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const postV1RolesMutation = (options?: Partial<Options<PostV1RolesData>>): UseMutationOptions<PostV1RolesResponse, DefaultError, Options<PostV1RolesData>> => {
    const mutationOptions: UseMutationOptions<PostV1RolesResponse, DefaultError, Options<PostV1RolesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postV1Roles({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const deleteV1RolesByIdMutation = (options?: Partial<Options<DeleteV1RolesByIdData>>): UseMutationOptions<unknown, DefaultError, Options<DeleteV1RolesByIdData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<DeleteV1RolesByIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteV1RolesById({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getV1RolesByIdQueryKey = (options: Options<GetV1RolesByIdData>) => createQueryKey('getV1RolesById', options);

export const getV1RolesByIdOptions = (options: Options<GetV1RolesByIdData>) => queryOptions<GetV1RolesByIdResponse, DefaultError, GetV1RolesByIdResponse, ReturnType<typeof getV1RolesByIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getV1RolesById({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getV1RolesByIdQueryKey(options)
});

export const patchV1RolesByIdMutation = (options?: Partial<Options<PatchV1RolesByIdData>>): UseMutationOptions<PatchV1RolesByIdResponse, DefaultError, Options<PatchV1RolesByIdData>> => {
    const mutationOptions: UseMutationOptions<PatchV1RolesByIdResponse, DefaultError, Options<PatchV1RolesByIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await patchV1RolesById({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getV1WorkflowsQueryKey = (options: Options<GetV1WorkflowsData>) => createQueryKey('getV1Workflows', options);

export const getV1WorkflowsOptions = (options: Options<GetV1WorkflowsData>) => queryOptions<GetV1WorkflowsResponse, DefaultError, GetV1WorkflowsResponse, ReturnType<typeof getV1WorkflowsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getV1Workflows({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getV1WorkflowsQueryKey(options)
});

export const getV1WorkflowsInfiniteQueryKey = (options: Options<GetV1WorkflowsData>): QueryKey<Options<GetV1WorkflowsData>> => createQueryKey('getV1Workflows', options, true);

export const getV1WorkflowsInfiniteOptions = (options: Options<GetV1WorkflowsData>) => {
    const opts = infiniteQueryOptions<GetV1WorkflowsResponse, DefaultError, InfiniteData<GetV1WorkflowsResponse>, QueryKey<Options<GetV1WorkflowsData>>, number | Pick<QueryKey<Options<GetV1WorkflowsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetV1WorkflowsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getV1Workflows({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getV1WorkflowsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const postV1WorkflowsMutation = (options?: Partial<Options<PostV1WorkflowsData>>): UseMutationOptions<PostV1WorkflowsResponse, DefaultError, Options<PostV1WorkflowsData>> => {
    const mutationOptions: UseMutationOptions<PostV1WorkflowsResponse, DefaultError, Options<PostV1WorkflowsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postV1Workflows({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const deleteV1WorkflowsByIdMutation = (options?: Partial<Options<DeleteV1WorkflowsByIdData>>): UseMutationOptions<unknown, DefaultError, Options<DeleteV1WorkflowsByIdData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<DeleteV1WorkflowsByIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteV1WorkflowsById({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getV1WorkflowsByIdQueryKey = (options: Options<GetV1WorkflowsByIdData>) => createQueryKey('getV1WorkflowsById', options);

export const getV1WorkflowsByIdOptions = (options: Options<GetV1WorkflowsByIdData>) => queryOptions<GetV1WorkflowsByIdResponse, DefaultError, GetV1WorkflowsByIdResponse, ReturnType<typeof getV1WorkflowsByIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getV1WorkflowsById({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getV1WorkflowsByIdQueryKey(options)
});

export const patchV1WorkflowsByIdMutation = (options?: Partial<Options<PatchV1WorkflowsByIdData>>): UseMutationOptions<PatchV1WorkflowsByIdResponse, DefaultError, Options<PatchV1WorkflowsByIdData>> => {
    const mutationOptions: UseMutationOptions<PatchV1WorkflowsByIdResponse, DefaultError, Options<PatchV1WorkflowsByIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await patchV1WorkflowsById({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getV1WorkshopsByIdWorkflowsQueryKey = (options: Options<GetV1WorkshopsByIdWorkflowsData>) => createQueryKey('getV1WorkshopsByIdWorkflows', options);

export const getV1WorkshopsByIdWorkflowsOptions = (options: Options<GetV1WorkshopsByIdWorkflowsData>) => queryOptions<GetV1WorkshopsByIdWorkflowsResponse, DefaultError, GetV1WorkshopsByIdWorkflowsResponse, ReturnType<typeof getV1WorkshopsByIdWorkflowsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getV1WorkshopsByIdWorkflows({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getV1WorkshopsByIdWorkflowsQueryKey(options)
});

export const getV1WorkshopsQueryKey = (options: Options<GetV1WorkshopsData>) => createQueryKey('getV1Workshops', options);

export const getV1WorkshopsOptions = (options: Options<GetV1WorkshopsData>) => queryOptions<GetV1WorkshopsResponse, DefaultError, GetV1WorkshopsResponse, ReturnType<typeof getV1WorkshopsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getV1Workshops({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getV1WorkshopsQueryKey(options)
});

export const getV1WorkshopsInfiniteQueryKey = (options: Options<GetV1WorkshopsData>): QueryKey<Options<GetV1WorkshopsData>> => createQueryKey('getV1Workshops', options, true);

export const getV1WorkshopsInfiniteOptions = (options: Options<GetV1WorkshopsData>) => {
    const opts = infiniteQueryOptions<GetV1WorkshopsResponse, DefaultError, InfiniteData<GetV1WorkshopsResponse>, QueryKey<Options<GetV1WorkshopsData>>, number | Pick<QueryKey<Options<GetV1WorkshopsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetV1WorkshopsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getV1Workshops({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getV1WorkshopsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const postV1WorkshopsMutation = (options?: Partial<Options<PostV1WorkshopsData>>): UseMutationOptions<PostV1WorkshopsResponse, DefaultError, Options<PostV1WorkshopsData>> => {
    const mutationOptions: UseMutationOptions<PostV1WorkshopsResponse, DefaultError, Options<PostV1WorkshopsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postV1Workshops({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const deleteV1WorkshopsByIdMutation = (options?: Partial<Options<DeleteV1WorkshopsByIdData>>): UseMutationOptions<unknown, DefaultError, Options<DeleteV1WorkshopsByIdData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<DeleteV1WorkshopsByIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteV1WorkshopsById({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getV1WorkshopsByIdQueryKey = (options: Options<GetV1WorkshopsByIdData>) => createQueryKey('getV1WorkshopsById', options);

export const getV1WorkshopsByIdOptions = (options: Options<GetV1WorkshopsByIdData>) => queryOptions<GetV1WorkshopsByIdResponse, DefaultError, GetV1WorkshopsByIdResponse, ReturnType<typeof getV1WorkshopsByIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getV1WorkshopsById({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getV1WorkshopsByIdQueryKey(options)
});

export const patchV1WorkshopsByIdMutation = (options?: Partial<Options<PatchV1WorkshopsByIdData>>): UseMutationOptions<PatchV1WorkshopsByIdResponse, DefaultError, Options<PatchV1WorkshopsByIdData>> => {
    const mutationOptions: UseMutationOptions<PatchV1WorkshopsByIdResponse, DefaultError, Options<PatchV1WorkshopsByIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await patchV1WorkshopsById({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getV1WorkshopsByIdShelvesQueryKey = (options: Options<GetV1WorkshopsByIdShelvesData>) => createQueryKey('getV1WorkshopsByIdShelves', options);

export const getV1WorkshopsByIdShelvesOptions = (options: Options<GetV1WorkshopsByIdShelvesData>) => queryOptions<GetV1WorkshopsByIdShelvesResponse, DefaultError, GetV1WorkshopsByIdShelvesResponse, ReturnType<typeof getV1WorkshopsByIdShelvesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getV1WorkshopsByIdShelves({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getV1WorkshopsByIdShelvesQueryKey(options)
});

export const postV1WorkshopsByIdShelvesMutation = (options?: Partial<Options<PostV1WorkshopsByIdShelvesData>>): UseMutationOptions<PostV1WorkshopsByIdShelvesResponse, DefaultError, Options<PostV1WorkshopsByIdShelvesData>> => {
    const mutationOptions: UseMutationOptions<PostV1WorkshopsByIdShelvesResponse, DefaultError, Options<PostV1WorkshopsByIdShelvesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postV1WorkshopsByIdShelves({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const deleteV1WorkshopsByIdShelvesByShelfIdMutation = (options?: Partial<Options<DeleteV1WorkshopsByIdShelvesByShelfIdData>>): UseMutationOptions<unknown, DefaultError, Options<DeleteV1WorkshopsByIdShelvesByShelfIdData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<DeleteV1WorkshopsByIdShelvesByShelfIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteV1WorkshopsByIdShelvesByShelfId({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const patchV1WorkshopsByIdShelvesByShelfIdMutation = (options?: Partial<Options<PatchV1WorkshopsByIdShelvesByShelfIdData>>): UseMutationOptions<PatchV1WorkshopsByIdShelvesByShelfIdResponse, DefaultError, Options<PatchV1WorkshopsByIdShelvesByShelfIdData>> => {
    const mutationOptions: UseMutationOptions<PatchV1WorkshopsByIdShelvesByShelfIdResponse, DefaultError, Options<PatchV1WorkshopsByIdShelvesByShelfIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await patchV1WorkshopsByIdShelvesByShelfId({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getV1WorkshopsByIdDealershipsQueryKey = (options: Options<GetV1WorkshopsByIdDealershipsData>) => createQueryKey('getV1WorkshopsByIdDealerships', options);

export const getV1WorkshopsByIdDealershipsOptions = (options: Options<GetV1WorkshopsByIdDealershipsData>) => queryOptions<GetV1WorkshopsByIdDealershipsResponse, DefaultError, GetV1WorkshopsByIdDealershipsResponse, ReturnType<typeof getV1WorkshopsByIdDealershipsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getV1WorkshopsByIdDealerships({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getV1WorkshopsByIdDealershipsQueryKey(options)
});

export const postV1WorkshopsByIdDealershipsMutation = (options?: Partial<Options<PostV1WorkshopsByIdDealershipsData>>): UseMutationOptions<PostV1WorkshopsByIdDealershipsResponse, DefaultError, Options<PostV1WorkshopsByIdDealershipsData>> => {
    const mutationOptions: UseMutationOptions<PostV1WorkshopsByIdDealershipsResponse, DefaultError, Options<PostV1WorkshopsByIdDealershipsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postV1WorkshopsByIdDealerships({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const deleteV1WorkshopsByIdDealershipsByDealershipIdMutation = (options?: Partial<Options<DeleteV1WorkshopsByIdDealershipsByDealershipIdData>>): UseMutationOptions<unknown, DefaultError, Options<DeleteV1WorkshopsByIdDealershipsByDealershipIdData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<DeleteV1WorkshopsByIdDealershipsByDealershipIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteV1WorkshopsByIdDealershipsByDealershipId({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const patchV1WorkshopsByIdDealershipsByDealershipIdMutation = (options?: Partial<Options<PatchV1WorkshopsByIdDealershipsByDealershipIdData>>): UseMutationOptions<PatchV1WorkshopsByIdDealershipsByDealershipIdResponse, DefaultError, Options<PatchV1WorkshopsByIdDealershipsByDealershipIdData>> => {
    const mutationOptions: UseMutationOptions<PatchV1WorkshopsByIdDealershipsByDealershipIdResponse, DefaultError, Options<PatchV1WorkshopsByIdDealershipsByDealershipIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await patchV1WorkshopsByIdDealershipsByDealershipId({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getV1WorkshopsByIdCabAccountsQueryKey = (options: Options<GetV1WorkshopsByIdCabAccountsData>) => createQueryKey('getV1WorkshopsByIdCabAccounts', options);

export const getV1WorkshopsByIdCabAccountsOptions = (options: Options<GetV1WorkshopsByIdCabAccountsData>) => queryOptions<GetV1WorkshopsByIdCabAccountsResponse, DefaultError, GetV1WorkshopsByIdCabAccountsResponse, ReturnType<typeof getV1WorkshopsByIdCabAccountsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getV1WorkshopsByIdCabAccounts({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getV1WorkshopsByIdCabAccountsQueryKey(options)
});

export const postV1WorkshopsByIdCabAccountsMutation = (options?: Partial<Options<PostV1WorkshopsByIdCabAccountsData>>): UseMutationOptions<PostV1WorkshopsByIdCabAccountsResponse, DefaultError, Options<PostV1WorkshopsByIdCabAccountsData>> => {
    const mutationOptions: UseMutationOptions<PostV1WorkshopsByIdCabAccountsResponse, DefaultError, Options<PostV1WorkshopsByIdCabAccountsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postV1WorkshopsByIdCabAccounts({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const deleteV1WorkshopsByIdCabAccountsByCabAccountIdMutation = (options?: Partial<Options<DeleteV1WorkshopsByIdCabAccountsByCabAccountIdData>>): UseMutationOptions<unknown, DefaultError, Options<DeleteV1WorkshopsByIdCabAccountsByCabAccountIdData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<DeleteV1WorkshopsByIdCabAccountsByCabAccountIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteV1WorkshopsByIdCabAccountsByCabAccountId({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const patchV1WorkshopsByIdCabAccountsByCabAccountIdMutation = (options?: Partial<Options<PatchV1WorkshopsByIdCabAccountsByCabAccountIdData>>): UseMutationOptions<PatchV1WorkshopsByIdCabAccountsByCabAccountIdResponse, DefaultError, Options<PatchV1WorkshopsByIdCabAccountsByCabAccountIdData>> => {
    const mutationOptions: UseMutationOptions<PatchV1WorkshopsByIdCabAccountsByCabAccountIdResponse, DefaultError, Options<PatchV1WorkshopsByIdCabAccountsByCabAccountIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await patchV1WorkshopsByIdCabAccountsByCabAccountId({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getV1CarsQueryKey = (options: Options<GetV1CarsData>) => createQueryKey('getV1Cars', options);

export const getV1CarsOptions = (options: Options<GetV1CarsData>) => queryOptions<GetV1CarsResponse, DefaultError, GetV1CarsResponse, ReturnType<typeof getV1CarsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getV1Cars({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getV1CarsQueryKey(options)
});

export const getV1CarsInfiniteQueryKey = (options: Options<GetV1CarsData>): QueryKey<Options<GetV1CarsData>> => createQueryKey('getV1Cars', options, true);

export const getV1CarsInfiniteOptions = (options: Options<GetV1CarsData>) => {
    const opts = infiniteQueryOptions<GetV1CarsResponse, DefaultError, InfiniteData<GetV1CarsResponse>, QueryKey<Options<GetV1CarsData>>, number | Pick<QueryKey<Options<GetV1CarsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetV1CarsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getV1Cars({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getV1CarsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const getV1CarsByIdQueryKey = (options: Options<GetV1CarsByIdData>) => createQueryKey('getV1CarsById', options);

export const getV1CarsByIdOptions = (options: Options<GetV1CarsByIdData>) => queryOptions<GetV1CarsByIdResponse, DefaultError, GetV1CarsByIdResponse, ReturnType<typeof getV1CarsByIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getV1CarsById({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getV1CarsByIdQueryKey(options)
});

export const patchV1ClientsByIdOverridesMutation = (options?: Partial<Options<PatchV1ClientsByIdOverridesData>>): UseMutationOptions<PatchV1ClientsByIdOverridesResponse, DefaultError, Options<PatchV1ClientsByIdOverridesData>> => {
    const mutationOptions: UseMutationOptions<PatchV1ClientsByIdOverridesResponse, DefaultError, Options<PatchV1ClientsByIdOverridesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await patchV1ClientsByIdOverrides({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getV1WorkOrdersQueryKey = (options: Options<GetV1WorkOrdersData>) => createQueryKey('getV1WorkOrders', options);

export const getV1WorkOrdersOptions = (options: Options<GetV1WorkOrdersData>) => queryOptions<GetV1WorkOrdersResponse, DefaultError, GetV1WorkOrdersResponse, ReturnType<typeof getV1WorkOrdersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getV1WorkOrders({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getV1WorkOrdersQueryKey(options)
});

export const getV1WorkOrdersInfiniteQueryKey = (options: Options<GetV1WorkOrdersData>): QueryKey<Options<GetV1WorkOrdersData>> => createQueryKey('getV1WorkOrders', options, true);

export const getV1WorkOrdersInfiniteOptions = (options: Options<GetV1WorkOrdersData>) => {
    const opts = infiniteQueryOptions<GetV1WorkOrdersResponse, DefaultError, InfiniteData<GetV1WorkOrdersResponse>, QueryKey<Options<GetV1WorkOrdersData>>, number | Pick<QueryKey<Options<GetV1WorkOrdersData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetV1WorkOrdersData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getV1WorkOrders({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getV1WorkOrdersInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const getV1WorkOrdersLateOrdersQueryKey = (options?: Options<GetV1WorkOrdersLateOrdersData>) => createQueryKey('getV1WorkOrdersLateOrders', options);

export const getV1WorkOrdersLateOrdersOptions = (options?: Options<GetV1WorkOrdersLateOrdersData>) => queryOptions<GetV1WorkOrdersLateOrdersResponse, DefaultError, GetV1WorkOrdersLateOrdersResponse, ReturnType<typeof getV1WorkOrdersLateOrdersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getV1WorkOrdersLateOrders({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getV1WorkOrdersLateOrdersQueryKey(options)
});

export const getV1WorkOrdersTimeEntriesByUserIdQueryKey = (options: Options<GetV1WorkOrdersTimeEntriesByUserIdData>) => createQueryKey('getV1WorkOrdersTimeEntriesByUserId', options);

export const getV1WorkOrdersTimeEntriesByUserIdOptions = (options: Options<GetV1WorkOrdersTimeEntriesByUserIdData>) => queryOptions<GetV1WorkOrdersTimeEntriesByUserIdResponse, DefaultError, GetV1WorkOrdersTimeEntriesByUserIdResponse, ReturnType<typeof getV1WorkOrdersTimeEntriesByUserIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getV1WorkOrdersTimeEntriesByUserId({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getV1WorkOrdersTimeEntriesByUserIdQueryKey(options)
});

export const getV1WorkOrdersAssignedByUserIdQueryKey = (options: Options<GetV1WorkOrdersAssignedByUserIdData>) => createQueryKey('getV1WorkOrdersAssignedByUserId', options);

export const getV1WorkOrdersAssignedByUserIdOptions = (options: Options<GetV1WorkOrdersAssignedByUserIdData>) => queryOptions<GetV1WorkOrdersAssignedByUserIdResponse, DefaultError, GetV1WorkOrdersAssignedByUserIdResponse, ReturnType<typeof getV1WorkOrdersAssignedByUserIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getV1WorkOrdersAssignedByUserId({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getV1WorkOrdersAssignedByUserIdQueryKey(options)
});

export const getV1WorkOrdersByIdQueryKey = (options: Options<GetV1WorkOrdersByIdData>) => createQueryKey('getV1WorkOrdersById', options);

export const getV1WorkOrdersByIdOptions = (options: Options<GetV1WorkOrdersByIdData>) => queryOptions<GetV1WorkOrdersByIdResponse, DefaultError, GetV1WorkOrdersByIdResponse, ReturnType<typeof getV1WorkOrdersByIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getV1WorkOrdersById({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getV1WorkOrdersByIdQueryKey(options)
});

export const patchV1WorkOrdersByIdMutation = (options?: Partial<Options<PatchV1WorkOrdersByIdData>>): UseMutationOptions<PatchV1WorkOrdersByIdResponse, DefaultError, Options<PatchV1WorkOrdersByIdData>> => {
    const mutationOptions: UseMutationOptions<PatchV1WorkOrdersByIdResponse, DefaultError, Options<PatchV1WorkOrdersByIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await patchV1WorkOrdersById({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postV1WorkOrdersByIdMoveMutation = (options?: Partial<Options<PostV1WorkOrdersByIdMoveData>>): UseMutationOptions<PostV1WorkOrdersByIdMoveResponse, DefaultError, Options<PostV1WorkOrdersByIdMoveData>> => {
    const mutationOptions: UseMutationOptions<PostV1WorkOrdersByIdMoveResponse, DefaultError, Options<PostV1WorkOrdersByIdMoveData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postV1WorkOrdersByIdMove({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postV1WorkOrdersByIdRepairPartsSendToPaintMutation = (options?: Partial<Options<PostV1WorkOrdersByIdRepairPartsSendToPaintData>>): UseMutationOptions<PostV1WorkOrdersByIdRepairPartsSendToPaintResponse, DefaultError, Options<PostV1WorkOrdersByIdRepairPartsSendToPaintData>> => {
    const mutationOptions: UseMutationOptions<PostV1WorkOrdersByIdRepairPartsSendToPaintResponse, DefaultError, Options<PostV1WorkOrdersByIdRepairPartsSendToPaintData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postV1WorkOrdersByIdRepairPartsSendToPaint({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const patchV1WorkOrdersByIdPaintedLackItemsMutation = (options?: Partial<Options<PatchV1WorkOrdersByIdPaintedLackItemsData>>): UseMutationOptions<PatchV1WorkOrdersByIdPaintedLackItemsResponse, DefaultError, Options<PatchV1WorkOrdersByIdPaintedLackItemsData>> => {
    const mutationOptions: UseMutationOptions<PatchV1WorkOrdersByIdPaintedLackItemsResponse, DefaultError, Options<PatchV1WorkOrdersByIdPaintedLackItemsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await patchV1WorkOrdersByIdPaintedLackItems({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postV1WorkOrdersByIdPlannedMutation = (options?: Partial<Options<PostV1WorkOrdersByIdPlannedData>>): UseMutationOptions<PostV1WorkOrdersByIdPlannedResponse, DefaultError, Options<PostV1WorkOrdersByIdPlannedData>> => {
    const mutationOptions: UseMutationOptions<PostV1WorkOrdersByIdPlannedResponse, DefaultError, Options<PostV1WorkOrdersByIdPlannedData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postV1WorkOrdersByIdPlanned({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const patchV1WorkOrdersByIdTimeMutation = (options?: Partial<Options<PatchV1WorkOrdersByIdTimeData>>): UseMutationOptions<PatchV1WorkOrdersByIdTimeResponse, DefaultError, Options<PatchV1WorkOrdersByIdTimeData>> => {
    const mutationOptions: UseMutationOptions<PatchV1WorkOrdersByIdTimeResponse, DefaultError, Options<PatchV1WorkOrdersByIdTimeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await patchV1WorkOrdersByIdTime({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postV1WorkOrdersByIdTimeMutation = (options?: Partial<Options<PostV1WorkOrdersByIdTimeData>>): UseMutationOptions<PostV1WorkOrdersByIdTimeResponse, DefaultError, Options<PostV1WorkOrdersByIdTimeData>> => {
    const mutationOptions: UseMutationOptions<PostV1WorkOrdersByIdTimeResponse, DefaultError, Options<PostV1WorkOrdersByIdTimeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postV1WorkOrdersByIdTime({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postV1WorkOrdersByIdTimeEntryMutation = (options?: Partial<Options<PostV1WorkOrdersByIdTimeEntryData>>): UseMutationOptions<PostV1WorkOrdersByIdTimeEntryResponse, DefaultError, Options<PostV1WorkOrdersByIdTimeEntryData>> => {
    const mutationOptions: UseMutationOptions<PostV1WorkOrdersByIdTimeEntryResponse, DefaultError, Options<PostV1WorkOrdersByIdTimeEntryData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postV1WorkOrdersByIdTimeEntry({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postV1WorkOrdersByIdSignatureLinkMutation = (options?: Partial<Options<PostV1WorkOrdersByIdSignatureLinkData>>): UseMutationOptions<PostV1WorkOrdersByIdSignatureLinkResponse, DefaultError, Options<PostV1WorkOrdersByIdSignatureLinkData>> => {
    const mutationOptions: UseMutationOptions<PostV1WorkOrdersByIdSignatureLinkResponse, DefaultError, Options<PostV1WorkOrdersByIdSignatureLinkData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postV1WorkOrdersByIdSignatureLink({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postV1WorkOrdersByIdSignMutation = (options?: Partial<Options<PostV1WorkOrdersByIdSignData>>): UseMutationOptions<unknown, DefaultError, Options<PostV1WorkOrdersByIdSignData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<PostV1WorkOrdersByIdSignData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postV1WorkOrdersByIdSign({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postV1WorkOrdersByIdSendSignatureRequestMutation = (options?: Partial<Options<PostV1WorkOrdersByIdSendSignatureRequestData>>): UseMutationOptions<unknown, DefaultError, Options<PostV1WorkOrdersByIdSendSignatureRequestData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<PostV1WorkOrdersByIdSendSignatureRequestData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postV1WorkOrdersByIdSendSignatureRequest({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const deleteV1WorkOrdersByIdSignaturesBySignatureTypeMutation = (options?: Partial<Options<DeleteV1WorkOrdersByIdSignaturesBySignatureTypeData>>): UseMutationOptions<unknown, DefaultError, Options<DeleteV1WorkOrdersByIdSignaturesBySignatureTypeData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<DeleteV1WorkOrdersByIdSignaturesBySignatureTypeData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteV1WorkOrdersByIdSignaturesBySignatureType({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postV1WorkOrdersByIdUploadedImagesUploadUrlsMutation = (options?: Partial<Options<PostV1WorkOrdersByIdUploadedImagesUploadUrlsData>>): UseMutationOptions<PostV1WorkOrdersByIdUploadedImagesUploadUrlsResponse, DefaultError, Options<PostV1WorkOrdersByIdUploadedImagesUploadUrlsData>> => {
    const mutationOptions: UseMutationOptions<PostV1WorkOrdersByIdUploadedImagesUploadUrlsResponse, DefaultError, Options<PostV1WorkOrdersByIdUploadedImagesUploadUrlsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postV1WorkOrdersByIdUploadedImagesUploadUrls({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const deleteV1WorkOrdersByIdUploadedImagesMutation = (options?: Partial<Options<DeleteV1WorkOrdersByIdUploadedImagesData>>): UseMutationOptions<DeleteV1WorkOrdersByIdUploadedImagesResponse, DefaultError, Options<DeleteV1WorkOrdersByIdUploadedImagesData>> => {
    const mutationOptions: UseMutationOptions<DeleteV1WorkOrdersByIdUploadedImagesResponse, DefaultError, Options<DeleteV1WorkOrdersByIdUploadedImagesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteV1WorkOrdersByIdUploadedImages({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postV1WorkOrdersByIdUploadedImagesMutation = (options?: Partial<Options<PostV1WorkOrdersByIdUploadedImagesData>>): UseMutationOptions<PostV1WorkOrdersByIdUploadedImagesResponse, DefaultError, Options<PostV1WorkOrdersByIdUploadedImagesData>> => {
    const mutationOptions: UseMutationOptions<PostV1WorkOrdersByIdUploadedImagesResponse, DefaultError, Options<PostV1WorkOrdersByIdUploadedImagesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postV1WorkOrdersByIdUploadedImages({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getV1WorkOrdersSearchQueryKey = (options: Options<GetV1WorkOrdersSearchData>) => createQueryKey('getV1WorkOrdersSearch', options);

export const getV1WorkOrdersSearchOptions = (options: Options<GetV1WorkOrdersSearchData>) => queryOptions<GetV1WorkOrdersSearchResponse, DefaultError, GetV1WorkOrdersSearchResponse, ReturnType<typeof getV1WorkOrdersSearchQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getV1WorkOrdersSearch({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getV1WorkOrdersSearchQueryKey(options)
});

export const getV1WorkOrdersSearchInfiniteQueryKey = (options: Options<GetV1WorkOrdersSearchData>): QueryKey<Options<GetV1WorkOrdersSearchData>> => createQueryKey('getV1WorkOrdersSearch', options, true);

export const getV1WorkOrdersSearchInfiniteOptions = (options: Options<GetV1WorkOrdersSearchData>) => {
    const opts = infiniteQueryOptions<GetV1WorkOrdersSearchResponse, DefaultError, InfiniteData<GetV1WorkOrdersSearchResponse>, QueryKey<Options<GetV1WorkOrdersSearchData>>, number | Pick<QueryKey<Options<GetV1WorkOrdersSearchData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetV1WorkOrdersSearchData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getV1WorkOrdersSearch({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getV1WorkOrdersSearchInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const getV1JobsQueryKey = (options: Options<GetV1JobsData>) => createQueryKey('getV1Jobs', options);

export const getV1JobsOptions = (options: Options<GetV1JobsData>) => queryOptions<GetV1JobsResponse, DefaultError, GetV1JobsResponse, ReturnType<typeof getV1JobsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getV1Jobs({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getV1JobsQueryKey(options)
});

export const getV1JobsInfiniteQueryKey = (options: Options<GetV1JobsData>): QueryKey<Options<GetV1JobsData>> => createQueryKey('getV1Jobs', options, true);

export const getV1JobsInfiniteOptions = (options: Options<GetV1JobsData>) => {
    const opts = infiniteQueryOptions<GetV1JobsResponse, DefaultError, InfiniteData<GetV1JobsResponse>, QueryKey<Options<GetV1JobsData>>, number | Pick<QueryKey<Options<GetV1JobsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetV1JobsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getV1Jobs({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getV1JobsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const postV1JobsMutation = (options?: Partial<Options<PostV1JobsData>>): UseMutationOptions<PostV1JobsResponse, DefaultError, Options<PostV1JobsData>> => {
    const mutationOptions: UseMutationOptions<PostV1JobsResponse, DefaultError, Options<PostV1JobsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postV1Jobs({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const deleteV1JobsByIdMutation = (options?: Partial<Options<DeleteV1JobsByIdData>>): UseMutationOptions<unknown, DefaultError, Options<DeleteV1JobsByIdData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<DeleteV1JobsByIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteV1JobsById({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getV1JobsByIdQueryKey = (options: Options<GetV1JobsByIdData>) => createQueryKey('getV1JobsById', options);

export const getV1JobsByIdOptions = (options: Options<GetV1JobsByIdData>) => queryOptions<GetV1JobsByIdResponse, DefaultError, GetV1JobsByIdResponse, ReturnType<typeof getV1JobsByIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getV1JobsById({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getV1JobsByIdQueryKey(options)
});

export const patchV1JobsByIdMutation = (options?: Partial<Options<PatchV1JobsByIdData>>): UseMutationOptions<PatchV1JobsByIdResponse, DefaultError, Options<PatchV1JobsByIdData>> => {
    const mutationOptions: UseMutationOptions<PatchV1JobsByIdResponse, DefaultError, Options<PatchV1JobsByIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await patchV1JobsById({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const patchV1JobsByIdPlannedDateMutation = (options?: Partial<Options<PatchV1JobsByIdPlannedDateData>>): UseMutationOptions<PatchV1JobsByIdPlannedDateResponse, DefaultError, Options<PatchV1JobsByIdPlannedDateData>> => {
    const mutationOptions: UseMutationOptions<PatchV1JobsByIdPlannedDateResponse, DefaultError, Options<PatchV1JobsByIdPlannedDateData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await patchV1JobsByIdPlannedDate({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postV1TimeEntriesPunchMutation = (options?: Partial<Options<PostV1TimeEntriesPunchData>>): UseMutationOptions<PostV1TimeEntriesPunchResponse, DefaultError, Options<PostV1TimeEntriesPunchData>> => {
    const mutationOptions: UseMutationOptions<PostV1TimeEntriesPunchResponse, DefaultError, Options<PostV1TimeEntriesPunchData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postV1TimeEntriesPunch({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getV1TimeEntriesPunchStatusQueryKey = (options: Options<GetV1TimeEntriesPunchStatusData>) => createQueryKey('getV1TimeEntriesPunchStatus', options);

export const getV1TimeEntriesPunchStatusOptions = (options: Options<GetV1TimeEntriesPunchStatusData>) => queryOptions<GetV1TimeEntriesPunchStatusResponse, DefaultError, GetV1TimeEntriesPunchStatusResponse, ReturnType<typeof getV1TimeEntriesPunchStatusQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getV1TimeEntriesPunchStatus({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getV1TimeEntriesPunchStatusQueryKey(options)
});

export const postV1TimeEntriesJobMutation = (options?: Partial<Options<PostV1TimeEntriesJobData>>): UseMutationOptions<PostV1TimeEntriesJobResponse, DefaultError, Options<PostV1TimeEntriesJobData>> => {
    const mutationOptions: UseMutationOptions<PostV1TimeEntriesJobResponse, DefaultError, Options<PostV1TimeEntriesJobData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postV1TimeEntriesJob({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postV1TimeEntriesAbsenceMutation = (options?: Partial<Options<PostV1TimeEntriesAbsenceData>>): UseMutationOptions<PostV1TimeEntriesAbsenceResponse, DefaultError, Options<PostV1TimeEntriesAbsenceData>> => {
    const mutationOptions: UseMutationOptions<PostV1TimeEntriesAbsenceResponse, DefaultError, Options<PostV1TimeEntriesAbsenceData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postV1TimeEntriesAbsence({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const deleteV1TimeEntriesMutation = (options?: Partial<Options<DeleteV1TimeEntriesData>>): UseMutationOptions<unknown, DefaultError, Options<DeleteV1TimeEntriesData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<DeleteV1TimeEntriesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteV1TimeEntries({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getV1TimeEntriesQueryKey = (options: Options<GetV1TimeEntriesData>) => createQueryKey('getV1TimeEntries', options);

export const getV1TimeEntriesOptions = (options: Options<GetV1TimeEntriesData>) => queryOptions<GetV1TimeEntriesResponse, DefaultError, GetV1TimeEntriesResponse, ReturnType<typeof getV1TimeEntriesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getV1TimeEntries({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getV1TimeEntriesQueryKey(options)
});

export const getV1TimeEntriesInfiniteQueryKey = (options: Options<GetV1TimeEntriesData>): QueryKey<Options<GetV1TimeEntriesData>> => createQueryKey('getV1TimeEntries', options, true);

export const getV1TimeEntriesInfiniteOptions = (options: Options<GetV1TimeEntriesData>) => {
    const opts = infiniteQueryOptions<GetV1TimeEntriesResponse, DefaultError, InfiniteData<GetV1TimeEntriesResponse>, QueryKey<Options<GetV1TimeEntriesData>>, number | Pick<QueryKey<Options<GetV1TimeEntriesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetV1TimeEntriesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getV1TimeEntries({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getV1TimeEntriesInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const deleteV1TimeEntriesByIdMutation = (options?: Partial<Options<DeleteV1TimeEntriesByIdData>>): UseMutationOptions<unknown, DefaultError, Options<DeleteV1TimeEntriesByIdData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<DeleteV1TimeEntriesByIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteV1TimeEntriesById({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const patchV1TimeEntriesByIdMutation = (options?: Partial<Options<PatchV1TimeEntriesByIdData>>): UseMutationOptions<PatchV1TimeEntriesByIdResponse, DefaultError, Options<PatchV1TimeEntriesByIdData>> => {
    const mutationOptions: UseMutationOptions<PatchV1TimeEntriesByIdResponse, DefaultError, Options<PatchV1TimeEntriesByIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await patchV1TimeEntriesById({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getV1InvoicesQueryKey = (options: Options<GetV1InvoicesData>) => createQueryKey('getV1Invoices', options);

export const getV1InvoicesOptions = (options: Options<GetV1InvoicesData>) => queryOptions<GetV1InvoicesResponse, DefaultError, GetV1InvoicesResponse, ReturnType<typeof getV1InvoicesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getV1Invoices({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getV1InvoicesQueryKey(options)
});

export const getV1InvoicesInfiniteQueryKey = (options: Options<GetV1InvoicesData>): QueryKey<Options<GetV1InvoicesData>> => createQueryKey('getV1Invoices', options, true);

export const getV1InvoicesInfiniteOptions = (options: Options<GetV1InvoicesData>) => {
    const opts = infiniteQueryOptions<GetV1InvoicesResponse, DefaultError, InfiniteData<GetV1InvoicesResponse>, QueryKey<Options<GetV1InvoicesData>>, number | Pick<QueryKey<Options<GetV1InvoicesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetV1InvoicesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getV1Invoices({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getV1InvoicesInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const postV1InvoicesMutation = (options?: Partial<Options<PostV1InvoicesData>>): UseMutationOptions<PostV1InvoicesResponse, DefaultError, Options<PostV1InvoicesData>> => {
    const mutationOptions: UseMutationOptions<PostV1InvoicesResponse, DefaultError, Options<PostV1InvoicesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postV1Invoices({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const deleteV1InvoicesByIdMutation = (options?: Partial<Options<DeleteV1InvoicesByIdData>>): UseMutationOptions<unknown, DefaultError, Options<DeleteV1InvoicesByIdData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<DeleteV1InvoicesByIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteV1InvoicesById({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getV1InvoicesByIdQueryKey = (options: Options<GetV1InvoicesByIdData>) => createQueryKey('getV1InvoicesById', options);

export const getV1InvoicesByIdOptions = (options: Options<GetV1InvoicesByIdData>) => queryOptions<GetV1InvoicesByIdResponse, DefaultError, GetV1InvoicesByIdResponse, ReturnType<typeof getV1InvoicesByIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getV1InvoicesById({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getV1InvoicesByIdQueryKey(options)
});

export const patchV1InvoicesByIdMutation = (options?: Partial<Options<PatchV1InvoicesByIdData>>): UseMutationOptions<PatchV1InvoicesByIdResponse, DefaultError, Options<PatchV1InvoicesByIdData>> => {
    const mutationOptions: UseMutationOptions<PatchV1InvoicesByIdResponse, DefaultError, Options<PatchV1InvoicesByIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await patchV1InvoicesById({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getV1CheckpointResponsesQueryKey = (options: Options<GetV1CheckpointResponsesData>) => createQueryKey('getV1CheckpointResponses', options);

export const getV1CheckpointResponsesOptions = (options: Options<GetV1CheckpointResponsesData>) => queryOptions<GetV1CheckpointResponsesResponse, DefaultError, GetV1CheckpointResponsesResponse, ReturnType<typeof getV1CheckpointResponsesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getV1CheckpointResponses({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getV1CheckpointResponsesQueryKey(options)
});

export const getV1CheckpointResponsesInfiniteQueryKey = (options: Options<GetV1CheckpointResponsesData>): QueryKey<Options<GetV1CheckpointResponsesData>> => createQueryKey('getV1CheckpointResponses', options, true);

export const getV1CheckpointResponsesInfiniteOptions = (options: Options<GetV1CheckpointResponsesData>) => {
    const opts = infiniteQueryOptions<GetV1CheckpointResponsesResponse, DefaultError, InfiniteData<GetV1CheckpointResponsesResponse>, QueryKey<Options<GetV1CheckpointResponsesData>>, number | Pick<QueryKey<Options<GetV1CheckpointResponsesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetV1CheckpointResponsesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getV1CheckpointResponses({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getV1CheckpointResponsesInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const postV1CheckpointResponsesMutation = (options?: Partial<Options<PostV1CheckpointResponsesData>>): UseMutationOptions<PostV1CheckpointResponsesResponse, DefaultError, Options<PostV1CheckpointResponsesData>> => {
    const mutationOptions: UseMutationOptions<PostV1CheckpointResponsesResponse, DefaultError, Options<PostV1CheckpointResponsesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postV1CheckpointResponses({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getV1CheckpointResponsesImagesQueryKey = (options: Options<GetV1CheckpointResponsesImagesData>) => createQueryKey('getV1CheckpointResponsesImages', options);

export const getV1CheckpointResponsesImagesOptions = (options: Options<GetV1CheckpointResponsesImagesData>) => queryOptions<GetV1CheckpointResponsesImagesResponse, DefaultError, GetV1CheckpointResponsesImagesResponse, ReturnType<typeof getV1CheckpointResponsesImagesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getV1CheckpointResponsesImages({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getV1CheckpointResponsesImagesQueryKey(options)
});

export const getV1CheckpointResponsesByIdQueryKey = (options: Options<GetV1CheckpointResponsesByIdData>) => createQueryKey('getV1CheckpointResponsesById', options);

export const getV1CheckpointResponsesByIdOptions = (options: Options<GetV1CheckpointResponsesByIdData>) => queryOptions<GetV1CheckpointResponsesByIdResponse, DefaultError, GetV1CheckpointResponsesByIdResponse, ReturnType<typeof getV1CheckpointResponsesByIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getV1CheckpointResponsesById({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getV1CheckpointResponsesByIdQueryKey(options)
});

export const patchV1CheckpointResponsesByIdMutation = (options?: Partial<Options<PatchV1CheckpointResponsesByIdData>>): UseMutationOptions<PatchV1CheckpointResponsesByIdResponse, DefaultError, Options<PatchV1CheckpointResponsesByIdData>> => {
    const mutationOptions: UseMutationOptions<PatchV1CheckpointResponsesByIdResponse, DefaultError, Options<PatchV1CheckpointResponsesByIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await patchV1CheckpointResponsesById({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postV1CheckpointResponsesUploadUrlsMutation = (options?: Partial<Options<PostV1CheckpointResponsesUploadUrlsData>>): UseMutationOptions<PostV1CheckpointResponsesUploadUrlsResponse, DefaultError, Options<PostV1CheckpointResponsesUploadUrlsData>> => {
    const mutationOptions: UseMutationOptions<PostV1CheckpointResponsesUploadUrlsResponse, DefaultError, Options<PostV1CheckpointResponsesUploadUrlsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postV1CheckpointResponsesUploadUrls({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getV1CabasEstimatesQueryKey = (options: Options<GetV1CabasEstimatesData>) => createQueryKey('getV1CabasEstimates', options);

export const getV1CabasEstimatesOptions = (options: Options<GetV1CabasEstimatesData>) => queryOptions<GetV1CabasEstimatesResponse, DefaultError, GetV1CabasEstimatesResponse, ReturnType<typeof getV1CabasEstimatesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getV1CabasEstimates({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getV1CabasEstimatesQueryKey(options)
});

export const getV1CabasEstimatesInfiniteQueryKey = (options: Options<GetV1CabasEstimatesData>): QueryKey<Options<GetV1CabasEstimatesData>> => createQueryKey('getV1CabasEstimates', options, true);

export const getV1CabasEstimatesInfiniteOptions = (options: Options<GetV1CabasEstimatesData>) => {
    const opts = infiniteQueryOptions<GetV1CabasEstimatesResponse, DefaultError, InfiniteData<GetV1CabasEstimatesResponse>, QueryKey<Options<GetV1CabasEstimatesData>>, number | Pick<QueryKey<Options<GetV1CabasEstimatesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetV1CabasEstimatesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getV1CabasEstimates({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getV1CabasEstimatesInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const getV1CabasEstimatesByIdQueryKey = (options: Options<GetV1CabasEstimatesByIdData>) => createQueryKey('getV1CabasEstimatesById', options);

export const getV1CabasEstimatesByIdOptions = (options: Options<GetV1CabasEstimatesByIdData>) => queryOptions<GetV1CabasEstimatesByIdResponse, DefaultError, GetV1CabasEstimatesByIdResponse, ReturnType<typeof getV1CabasEstimatesByIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getV1CabasEstimatesById({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getV1CabasEstimatesByIdQueryKey(options)
});

export const getV1CapacityQueryKey = (options: Options<GetV1CapacityData>) => createQueryKey('getV1Capacity', options);

export const getV1CapacityOptions = (options: Options<GetV1CapacityData>) => queryOptions<GetV1CapacityResponse, DefaultError, GetV1CapacityResponse, ReturnType<typeof getV1CapacityQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getV1Capacity({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getV1CapacityQueryKey(options)
});

export const getV1FinalCalculationsQueryKey = (options: Options<GetV1FinalCalculationsData>) => createQueryKey('getV1FinalCalculations', options);

export const getV1FinalCalculationsOptions = (options: Options<GetV1FinalCalculationsData>) => queryOptions<GetV1FinalCalculationsResponse, DefaultError, GetV1FinalCalculationsResponse, ReturnType<typeof getV1FinalCalculationsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getV1FinalCalculations({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getV1FinalCalculationsQueryKey(options)
});

export const getV1SparePartsQueryKey = (options: Options<GetV1SparePartsData>) => createQueryKey('getV1SpareParts', options);

export const getV1SparePartsOptions = (options: Options<GetV1SparePartsData>) => queryOptions<GetV1SparePartsResponse, GetV1SparePartsError, GetV1SparePartsResponse, ReturnType<typeof getV1SparePartsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getV1SpareParts({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getV1SparePartsQueryKey(options)
});

export const getV1SparePartsInfiniteQueryKey = (options: Options<GetV1SparePartsData>): QueryKey<Options<GetV1SparePartsData>> => createQueryKey('getV1SpareParts', options, true);

export const getV1SparePartsInfiniteOptions = (options: Options<GetV1SparePartsData>) => {
    const opts = infiniteQueryOptions<GetV1SparePartsResponse, GetV1SparePartsError, InfiniteData<GetV1SparePartsResponse>, QueryKey<Options<GetV1SparePartsData>>, number | Pick<QueryKey<Options<GetV1SparePartsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetV1SparePartsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getV1SpareParts({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getV1SparePartsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const patchV1SparePartsMutation = (options?: Partial<Options<PatchV1SparePartsData>>): UseMutationOptions<PatchV1SparePartsResponse, DefaultError, Options<PatchV1SparePartsData>> => {
    const mutationOptions: UseMutationOptions<PatchV1SparePartsResponse, DefaultError, Options<PatchV1SparePartsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await patchV1SpareParts({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const deleteV1SparePartsByIdMutation = (options?: Partial<Options<DeleteV1SparePartsByIdData>>): UseMutationOptions<unknown, DefaultError, Options<DeleteV1SparePartsByIdData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<DeleteV1SparePartsByIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteV1SparePartsById({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getV1SparePartOrdersQueryKey = (options: Options<GetV1SparePartOrdersData>) => createQueryKey('getV1SparePartOrders', options);

export const getV1SparePartOrdersOptions = (options: Options<GetV1SparePartOrdersData>) => queryOptions<GetV1SparePartOrdersResponse, DefaultError, GetV1SparePartOrdersResponse, ReturnType<typeof getV1SparePartOrdersQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getV1SparePartOrders({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getV1SparePartOrdersQueryKey(options)
});

export const postV1SparePartOrdersMutation = (options?: Partial<Options<PostV1SparePartOrdersData>>): UseMutationOptions<PostV1SparePartOrdersResponse, DefaultError, Options<PostV1SparePartOrdersData>> => {
    const mutationOptions: UseMutationOptions<PostV1SparePartOrdersResponse, DefaultError, Options<PostV1SparePartOrdersData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postV1SparePartOrders({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getV1SparePartOrdersByIdQueryKey = (options: Options<GetV1SparePartOrdersByIdData>) => createQueryKey('getV1SparePartOrdersById', options);

export const getV1SparePartOrdersByIdOptions = (options: Options<GetV1SparePartOrdersByIdData>) => queryOptions<GetV1SparePartOrdersByIdResponse, DefaultError, GetV1SparePartOrdersByIdResponse, ReturnType<typeof getV1SparePartOrdersByIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getV1SparePartOrdersById({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getV1SparePartOrdersByIdQueryKey(options)
});

export const patchV1SparePartOrdersByIdMutation = (options?: Partial<Options<PatchV1SparePartOrdersByIdData>>): UseMutationOptions<PatchV1SparePartOrdersByIdResponse, DefaultError, Options<PatchV1SparePartOrdersByIdData>> => {
    const mutationOptions: UseMutationOptions<PatchV1SparePartOrdersByIdResponse, DefaultError, Options<PatchV1SparePartOrdersByIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await patchV1SparePartOrdersById({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postV1SparePartOrdersByIdSendMutation = (options?: Partial<Options<PostV1SparePartOrdersByIdSendData>>): UseMutationOptions<PostV1SparePartOrdersByIdSendResponse, DefaultError, Options<PostV1SparePartOrdersByIdSendData>> => {
    const mutationOptions: UseMutationOptions<PostV1SparePartOrdersByIdSendResponse, DefaultError, Options<PostV1SparePartOrdersByIdSendData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postV1SparePartOrdersByIdSend({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const patchV1RepairPartsStatusMutation = (options?: Partial<Options<PatchV1RepairPartsStatusData>>): UseMutationOptions<PatchV1RepairPartsStatusResponse, DefaultError, Options<PatchV1RepairPartsStatusData>> => {
    const mutationOptions: UseMutationOptions<PatchV1RepairPartsStatusResponse, DefaultError, Options<PatchV1RepairPartsStatusData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await patchV1RepairPartsStatus({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getV1CommunicationQueryKey = (options: Options<GetV1CommunicationData>) => createQueryKey('getV1Communication', options);

export const getV1CommunicationOptions = (options: Options<GetV1CommunicationData>) => queryOptions<GetV1CommunicationResponse, DefaultError, GetV1CommunicationResponse, ReturnType<typeof getV1CommunicationQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getV1Communication({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getV1CommunicationQueryKey(options)
});

export const getV1CommunicationInfiniteQueryKey = (options: Options<GetV1CommunicationData>): QueryKey<Options<GetV1CommunicationData>> => createQueryKey('getV1Communication', options, true);

export const getV1CommunicationInfiniteOptions = (options: Options<GetV1CommunicationData>) => {
    const opts = infiniteQueryOptions<GetV1CommunicationResponse, DefaultError, InfiniteData<GetV1CommunicationResponse>, QueryKey<Options<GetV1CommunicationData>>, number | Pick<QueryKey<Options<GetV1CommunicationData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetV1CommunicationData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getV1Communication({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getV1CommunicationInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const postV1CommunicationMutation = (options?: Partial<Options<PostV1CommunicationData>>): UseMutationOptions<PostV1CommunicationResponse, DefaultError, Options<PostV1CommunicationData>> => {
    const mutationOptions: UseMutationOptions<PostV1CommunicationResponse, DefaultError, Options<PostV1CommunicationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postV1Communication({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getV1CommunicationByIdQueryKey = (options: Options<GetV1CommunicationByIdData>) => createQueryKey('getV1CommunicationById', options);

export const getV1CommunicationByIdOptions = (options: Options<GetV1CommunicationByIdData>) => queryOptions<GetV1CommunicationByIdResponse, DefaultError, GetV1CommunicationByIdResponse, ReturnType<typeof getV1CommunicationByIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getV1CommunicationById({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getV1CommunicationByIdQueryKey(options)
});

export const getV1SignatureLinksByTokenQueryKey = (options: Options<GetV1SignatureLinksByTokenData>) => createQueryKey('getV1SignatureLinksByToken', options);

export const getV1SignatureLinksByTokenOptions = (options: Options<GetV1SignatureLinksByTokenData>) => queryOptions<GetV1SignatureLinksByTokenResponse, DefaultError, GetV1SignatureLinksByTokenResponse, ReturnType<typeof getV1SignatureLinksByTokenQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getV1SignatureLinksByToken({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getV1SignatureLinksByTokenQueryKey(options)
});

export const postV1SignatureLinksByTokenSubmitMutation = (options?: Partial<Options<PostV1SignatureLinksByTokenSubmitData>>): UseMutationOptions<unknown, DefaultError, Options<PostV1SignatureLinksByTokenSubmitData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<PostV1SignatureLinksByTokenSubmitData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postV1SignatureLinksByTokenSubmit({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getV1CommunicationTemplatesQueryKey = (options: Options<GetV1CommunicationTemplatesData>) => createQueryKey('getV1CommunicationTemplates', options);

export const getV1CommunicationTemplatesOptions = (options: Options<GetV1CommunicationTemplatesData>) => queryOptions<GetV1CommunicationTemplatesResponse, DefaultError, GetV1CommunicationTemplatesResponse, ReturnType<typeof getV1CommunicationTemplatesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getV1CommunicationTemplates({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getV1CommunicationTemplatesQueryKey(options)
});

export const getV1CommunicationTemplatesInfiniteQueryKey = (options: Options<GetV1CommunicationTemplatesData>): QueryKey<Options<GetV1CommunicationTemplatesData>> => createQueryKey('getV1CommunicationTemplates', options, true);

export const getV1CommunicationTemplatesInfiniteOptions = (options: Options<GetV1CommunicationTemplatesData>) => {
    const opts = infiniteQueryOptions<GetV1CommunicationTemplatesResponse, DefaultError, InfiniteData<GetV1CommunicationTemplatesResponse>, QueryKey<Options<GetV1CommunicationTemplatesData>>, number | Pick<QueryKey<Options<GetV1CommunicationTemplatesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetV1CommunicationTemplatesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getV1CommunicationTemplates({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getV1CommunicationTemplatesInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const postV1CommunicationTemplatesMutation = (options?: Partial<Options<PostV1CommunicationTemplatesData>>): UseMutationOptions<PostV1CommunicationTemplatesResponse, DefaultError, Options<PostV1CommunicationTemplatesData>> => {
    const mutationOptions: UseMutationOptions<PostV1CommunicationTemplatesResponse, DefaultError, Options<PostV1CommunicationTemplatesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postV1CommunicationTemplates({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const deleteV1CommunicationTemplatesByIdMutation = (options?: Partial<Options<DeleteV1CommunicationTemplatesByIdData>>): UseMutationOptions<unknown, DefaultError, Options<DeleteV1CommunicationTemplatesByIdData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<DeleteV1CommunicationTemplatesByIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteV1CommunicationTemplatesById({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getV1CommunicationTemplatesByIdQueryKey = (options: Options<GetV1CommunicationTemplatesByIdData>) => createQueryKey('getV1CommunicationTemplatesById', options);

export const getV1CommunicationTemplatesByIdOptions = (options: Options<GetV1CommunicationTemplatesByIdData>) => queryOptions<GetV1CommunicationTemplatesByIdResponse, DefaultError, GetV1CommunicationTemplatesByIdResponse, ReturnType<typeof getV1CommunicationTemplatesByIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getV1CommunicationTemplatesById({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getV1CommunicationTemplatesByIdQueryKey(options)
});

export const patchV1CommunicationTemplatesByIdMutation = (options?: Partial<Options<PatchV1CommunicationTemplatesByIdData>>): UseMutationOptions<PatchV1CommunicationTemplatesByIdResponse, DefaultError, Options<PatchV1CommunicationTemplatesByIdData>> => {
    const mutationOptions: UseMutationOptions<PatchV1CommunicationTemplatesByIdResponse, DefaultError, Options<PatchV1CommunicationTemplatesByIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await patchV1CommunicationTemplatesById({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getV1WorkOrderErrandsQueryKey = (options: Options<GetV1WorkOrderErrandsData>) => createQueryKey('getV1WorkOrderErrands', options);

export const getV1WorkOrderErrandsOptions = (options: Options<GetV1WorkOrderErrandsData>) => queryOptions<GetV1WorkOrderErrandsResponse, DefaultError, GetV1WorkOrderErrandsResponse, ReturnType<typeof getV1WorkOrderErrandsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getV1WorkOrderErrands({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getV1WorkOrderErrandsQueryKey(options)
});

export const getV1WorkOrderErrandsInfiniteQueryKey = (options: Options<GetV1WorkOrderErrandsData>): QueryKey<Options<GetV1WorkOrderErrandsData>> => createQueryKey('getV1WorkOrderErrands', options, true);

export const getV1WorkOrderErrandsInfiniteOptions = (options: Options<GetV1WorkOrderErrandsData>) => {
    const opts = infiniteQueryOptions<GetV1WorkOrderErrandsResponse, DefaultError, InfiniteData<GetV1WorkOrderErrandsResponse>, QueryKey<Options<GetV1WorkOrderErrandsData>>, number | Pick<QueryKey<Options<GetV1WorkOrderErrandsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetV1WorkOrderErrandsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getV1WorkOrderErrands({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getV1WorkOrderErrandsInfiniteQueryKey(options)
    });
    return opts as Omit<typeof opts, 'initialData'>;
};

export const postV1WorkOrderErrandsMutation = (options?: Partial<Options<PostV1WorkOrderErrandsData>>): UseMutationOptions<PostV1WorkOrderErrandsResponse, DefaultError, Options<PostV1WorkOrderErrandsData>> => {
    const mutationOptions: UseMutationOptions<PostV1WorkOrderErrandsResponse, DefaultError, Options<PostV1WorkOrderErrandsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postV1WorkOrderErrands({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const deleteV1WorkOrderErrandsByIdMutation = (options?: Partial<Options<DeleteV1WorkOrderErrandsByIdData>>): UseMutationOptions<unknown, DefaultError, Options<DeleteV1WorkOrderErrandsByIdData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<DeleteV1WorkOrderErrandsByIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteV1WorkOrderErrandsById({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getV1WorkOrderErrandsByIdQueryKey = (options: Options<GetV1WorkOrderErrandsByIdData>) => createQueryKey('getV1WorkOrderErrandsById', options);

export const getV1WorkOrderErrandsByIdOptions = (options: Options<GetV1WorkOrderErrandsByIdData>) => queryOptions<GetV1WorkOrderErrandsByIdResponse, DefaultError, GetV1WorkOrderErrandsByIdResponse, ReturnType<typeof getV1WorkOrderErrandsByIdQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getV1WorkOrderErrandsById({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getV1WorkOrderErrandsByIdQueryKey(options)
});

export const patchV1WorkOrderErrandsByIdMutation = (options?: Partial<Options<PatchV1WorkOrderErrandsByIdData>>): UseMutationOptions<PatchV1WorkOrderErrandsByIdResponse, DefaultError, Options<PatchV1WorkOrderErrandsByIdData>> => {
    const mutationOptions: UseMutationOptions<PatchV1WorkOrderErrandsByIdResponse, DefaultError, Options<PatchV1WorkOrderErrandsByIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await patchV1WorkOrderErrandsById({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postV1WorkOrderErrandsUploadUrlsMutation = (options?: Partial<Options<PostV1WorkOrderErrandsUploadUrlsData>>): UseMutationOptions<PostV1WorkOrderErrandsUploadUrlsResponse, DefaultError, Options<PostV1WorkOrderErrandsUploadUrlsData>> => {
    const mutationOptions: UseMutationOptions<PostV1WorkOrderErrandsUploadUrlsResponse, DefaultError, Options<PostV1WorkOrderErrandsUploadUrlsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postV1WorkOrderErrandsUploadUrls({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getV1NotificationsQueryKey = (options: Options<GetV1NotificationsData>) => createQueryKey('getV1Notifications', options);

export const getV1NotificationsOptions = (options: Options<GetV1NotificationsData>) => queryOptions<GetV1NotificationsResponse, DefaultError, GetV1NotificationsResponse, ReturnType<typeof getV1NotificationsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getV1Notifications({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getV1NotificationsQueryKey(options)
});

export const getV1InsuranceCompaniesQueryKey = (options?: Options<GetV1InsuranceCompaniesData>) => createQueryKey('getV1InsuranceCompanies', options);

export const getV1InsuranceCompaniesOptions = (options?: Options<GetV1InsuranceCompaniesData>) => queryOptions<GetV1InsuranceCompaniesResponse, DefaultError, GetV1InsuranceCompaniesResponse, ReturnType<typeof getV1InsuranceCompaniesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getV1InsuranceCompanies({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getV1InsuranceCompaniesQueryKey(options)
});

export const getV1StopReasonsQueryKey = (options?: Options<GetV1StopReasonsData>) => createQueryKey('getV1StopReasons', options);

export const getV1StopReasonsOptions = (options?: Options<GetV1StopReasonsData>) => queryOptions<GetV1StopReasonsResponse, DefaultError, GetV1StopReasonsResponse, ReturnType<typeof getV1StopReasonsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getV1StopReasons({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getV1StopReasonsQueryKey(options)
});

export const getV1PunchReasonsQueryKey = (options?: Options<GetV1PunchReasonsData>) => createQueryKey('getV1PunchReasons', options);

export const getV1PunchReasonsOptions = (options?: Options<GetV1PunchReasonsData>) => queryOptions<GetV1PunchReasonsResponse, DefaultError, GetV1PunchReasonsResponse, ReturnType<typeof getV1PunchReasonsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getV1PunchReasons({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getV1PunchReasonsQueryKey(options)
});

export const getV1KioskDevicesQueryKey = (options: Options<GetV1KioskDevicesData>) => createQueryKey('getV1KioskDevices', options);

export const getV1KioskDevicesOptions = (options: Options<GetV1KioskDevicesData>) => queryOptions<GetV1KioskDevicesResponse, DefaultError, GetV1KioskDevicesResponse, ReturnType<typeof getV1KioskDevicesQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getV1KioskDevices({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getV1KioskDevicesQueryKey(options)
});

export const postV1KioskDevicesMutation = (options?: Partial<Options<PostV1KioskDevicesData>>): UseMutationOptions<PostV1KioskDevicesResponse, DefaultError, Options<PostV1KioskDevicesData>> => {
    const mutationOptions: UseMutationOptions<PostV1KioskDevicesResponse, DefaultError, Options<PostV1KioskDevicesData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postV1KioskDevices({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const deleteV1KioskDevicesByIdMutation = (options?: Partial<Options<DeleteV1KioskDevicesByIdData>>): UseMutationOptions<unknown, DefaultError, Options<DeleteV1KioskDevicesByIdData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<DeleteV1KioskDevicesByIdData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await deleteV1KioskDevicesById({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postV1KioskDevicesByIdRemoveMutation = (options?: Partial<Options<PostV1KioskDevicesByIdRemoveData>>): UseMutationOptions<unknown, DefaultError, Options<PostV1KioskDevicesByIdRemoveData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<PostV1KioskDevicesByIdRemoveData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postV1KioskDevicesByIdRemove({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postV1KioskPairMutation = (options?: Partial<Options<PostV1KioskPairData>>): UseMutationOptions<PostV1KioskPairResponse, DefaultError, Options<PostV1KioskPairData>> => {
    const mutationOptions: UseMutationOptions<PostV1KioskPairResponse, DefaultError, Options<PostV1KioskPairData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postV1KioskPair({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getV1KioskStaffQueryKey = (options: Options<GetV1KioskStaffData>) => createQueryKey('getV1KioskStaff', options);

export const getV1KioskStaffOptions = (options: Options<GetV1KioskStaffData>) => queryOptions<GetV1KioskStaffResponse, DefaultError, GetV1KioskStaffResponse, ReturnType<typeof getV1KioskStaffQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getV1KioskStaff({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getV1KioskStaffQueryKey(options)
});

export const getV1KioskStaffByUserIdPhotoQueryKey = (options: Options<GetV1KioskStaffByUserIdPhotoData>) => createQueryKey('getV1KioskStaffByUserIdPhoto', options);

export const getV1KioskStaffByUserIdPhotoOptions = (options: Options<GetV1KioskStaffByUserIdPhotoData>) => queryOptions<GetV1KioskStaffByUserIdPhotoResponse, DefaultError, GetV1KioskStaffByUserIdPhotoResponse, ReturnType<typeof getV1KioskStaffByUserIdPhotoQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getV1KioskStaffByUserIdPhoto({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getV1KioskStaffByUserIdPhotoQueryKey(options)
});

export const getV1KioskPunchReasonsQueryKey = (options: Options<GetV1KioskPunchReasonsData>) => createQueryKey('getV1KioskPunchReasons', options);

export const getV1KioskPunchReasonsOptions = (options: Options<GetV1KioskPunchReasonsData>) => queryOptions<GetV1KioskPunchReasonsResponse, DefaultError, GetV1KioskPunchReasonsResponse, ReturnType<typeof getV1KioskPunchReasonsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getV1KioskPunchReasons({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getV1KioskPunchReasonsQueryKey(options)
});

export const getV1KioskStopReasonsQueryKey = (options: Options<GetV1KioskStopReasonsData>) => createQueryKey('getV1KioskStopReasons', options);

export const getV1KioskStopReasonsOptions = (options: Options<GetV1KioskStopReasonsData>) => queryOptions<GetV1KioskStopReasonsResponse, DefaultError, GetV1KioskStopReasonsResponse, ReturnType<typeof getV1KioskStopReasonsQueryKey>>({
    queryFn: async ({ queryKey, signal }) => {
        const { data } = await getV1KioskStopReasons({
            ...options,
            ...queryKey[0],
            signal,
            throwOnError: true
        });
        return data;
    },
    queryKey: getV1KioskStopReasonsQueryKey(options)
});

export const postV1KioskSessionsMutation = (options?: Partial<Options<PostV1KioskSessionsData>>): UseMutationOptions<PostV1KioskSessionsResponse, DefaultError, Options<PostV1KioskSessionsData>> => {
    const mutationOptions: UseMutationOptions<PostV1KioskSessionsResponse, DefaultError, Options<PostV1KioskSessionsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postV1KioskSessions({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postV1KioskPinSetupVerifyPasswordMutation = (options?: Partial<Options<PostV1KioskPinSetupVerifyPasswordData>>): UseMutationOptions<PostV1KioskPinSetupVerifyPasswordResponse, DefaultError, Options<PostV1KioskPinSetupVerifyPasswordData>> => {
    const mutationOptions: UseMutationOptions<PostV1KioskPinSetupVerifyPasswordResponse, DefaultError, Options<PostV1KioskPinSetupVerifyPasswordData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postV1KioskPinSetupVerifyPassword({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postV1KioskPinSetupMutation = (options?: Partial<Options<PostV1KioskPinSetupData>>): UseMutationOptions<PostV1KioskPinSetupResponse, DefaultError, Options<PostV1KioskPinSetupData>> => {
    const mutationOptions: UseMutationOptions<PostV1KioskPinSetupResponse, DefaultError, Options<PostV1KioskPinSetupData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postV1KioskPinSetup({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const postV1KioskPunchMutation = (options?: Partial<Options<PostV1KioskPunchData>>): UseMutationOptions<PostV1KioskPunchResponse, DefaultError, Options<PostV1KioskPunchData>> => {
    const mutationOptions: UseMutationOptions<PostV1KioskPunchResponse, DefaultError, Options<PostV1KioskPunchData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await postV1KioskPunch({
                ...options,
                ...fnOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};
